import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import usePlatform from '../utils/usePlatform';
import { PlayIcon } from './StoreBadges';
import { storeUrl } from '../utils/storeUrl';

const DISMISS_KEY = 'rc_android_bar_dismissed';

/* Slim install bar shown only to Android visitors. Appears after a short delay
   so it never competes with the hero, and stays dismissed for 30 days. */
export default function AndroidInstallBar() {
  const platform = usePlatform();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (platform !== 'android') return undefined;
    try {
      const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
      if (until > Date.now()) return undefined;
    } catch { /* storage blocked - still show */ }
    const t = setTimeout(() => setShow(true), 3500);
    return () => clearTimeout(t);
  }, [platform]);

  if (!show) return null;

  const dismiss = () => {
    setShow(false);
    try { localStorage.setItem(DISMISS_KEY, String(Date.now() + 30 * 24 * 60 * 60 * 1000)); } catch { /* ignore */ }
  };

  return (
    <div
      data-testid="android-install-bar"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-slate-950/95 px-3 py-2.5 shadow-[0_-8px_24px_rgba(0,0,0,0.35)]"
    >
      <div className="mx-auto flex max-w-2xl items-center gap-3">
        <img src="/recalibrate-logo-optimized.png" alt="" width="36" height="36" className="h-9 w-9 rounded-lg" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-bold text-white">Recalibrate is on Google Play</p>
          <p className="truncate text-[11px] text-purple-200/70">Free to start · or keep using the web app</p>
        </div>
        <a
          href={storeUrl('install-bar')}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="android-install-bar-cta"
          className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 px-4 py-2.5 text-sm font-bold text-white"
        >
          <PlayIcon size="w-4 h-4" />
          Install
        </a>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          data-testid="android-install-bar-close"
          className="shrink-0 rounded-lg p-1.5 text-white/50 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
